<template>
  <div class="news-page">
    <!-- Hero Section -->
    <section class="hero">
      <div class="hero-background">
        <img :src="Images.news.background" alt="Background" class="hero-bg-image">
        <div class="hero-overlay"></div>
      </div>
      <div class="hero-content">
        <h1 class="hero-title">新闻中心</h1>
      </div>
    </section>
    
    <main class="news-content">
      <!-- 面包屑导航 -->
      <section class="breadcrumb-section">
        <div class="container">
          <nav class="breadcrumb">
            <router-link to="/home" class="breadcrumb-item">首页</router-link>
            <span class="breadcrumb-separator">/</span>
            <span class="breadcrumb-item active">新闻中心</span>
          </nav>
        </div>
      </section>
      
      <!-- 新闻内容区域 -->
      <section class="news-main">
        <div class="container">
          <!-- 搜索和分类 -->
          <div class="news-header">
            <div class="search-box">
              <input type="text" placeholder="搜索新闻..." class="search-input">
              <button class="search-btn">
                <img :src="Images.news.search" alt="搜索" class="search-icon">
              </button>
            </div>
            <div class="news-tabs">
              <span class="tab active">公司动态</span>
              <span class="tab">行业资讯</span>
              <span class="tab">媒体报道</span>
            </div>
          </div>
          
          <!-- 新闻列表和侧边栏 -->
          <div class="news-layout">
            <!-- 新闻列表 -->
            <div class="news-list">
              <div class="news-item">
                <div class="news-image">
                  <img :src="Images.news.new_1" alt="新闻图片">
                </div>
                <div class="news-info">
                  <div class="news-meta">
                    <span class="news-category">新闻资讯</span>
                    <span class="news-date">
                      <img :src="Images.news.time" alt="日期" class="date-icon">
                      2023-11-20
                    </span>
                  </div>
                  <h3 class="news-title">智慧城市与数字孪生怎么“生”？</h3>
                  <p class="news-excerpt">每一年的两会往往都会带来很多新鲜热词，尤其是赶上五年计划的年份，新概念尤为多。今年便是如此——随着全国两会的圆满落幕，“十四五”规划纲要也正式出炉。</p>
                  <a href="#" class="news-more">
                    阅读更多
                  </a>
                </div>
              </div>
              
              <div class="news-item">
                <div class="news-image">
                  <img :src="Images.news.new_2" alt="新闻图片">
                </div>
                <div class="news-info">
                  <div class="news-meta">
                    <span class="news-category">新闻资讯</span>
                    <span class="news-date">
                      <img :src="Images.news.time" alt="日期" class="date-icon">
                      2023-11-15
                    </span>
                  </div>
                  <h3 class="news-title">智能城市数字孪生怎么念？“生”？</h3>
                  <p class="news-excerpt">前有华为公司的智能助手“小艺”，后有小米公司的“小爱同学”。近日，百度公司在其世界大会上正式发布了自主研发的智能助手“文心一言”，引发了广泛关注。</p>
                  <a href="#" class="news-more">
                    阅读更多
                  </a>
                </div>
              </div>
              
              <div class="news-item">
                <div class="news-image">
                  <img :src="Images.news.new_3" alt="新闻图片">
                </div>
                <div class="news-info">
                  <div class="news-meta">
                    <span class="news-category">新闻资讯</span>
                    <span class="news-date">
                      <img :src="Images.news.time" alt="日期" class="date-icon">
                      2023-11-10
                    </span>
                  </div>
                  <h3 class="news-title">智能城市数字孪生怎么念？“生”？</h3>
                  <p class="news-excerpt">前有华为公司的智能助手“小艺”，后有小米公司的“小爱同学”。近日，百度公司在其世界大会上正式发布了自主研发的智能助手“文心一言”，引发了广泛关注。</p>
                  <a href="#" class="news-more">阅读更多</a>
                </div>
              </div>
              
              <div class="news-item">
                <div class="news-image">
                  <img :src="Images.news.new_4" alt="新闻图片">
                </div>
                <div class="news-info">
                  <div class="news-meta">
                    <span class="news-category">新闻资讯</span>
                    <span class="news-date">
                      <img :src="Images.news.time" alt="日期" class="date-icon">
                      2023-11-05
                    </span>
                  </div>
                  <h3 class="news-title">智能城市数字孪生怎么念？“生”？</h3>
                  <p class="news-excerpt">前有华为公司的智能助手“小艺”，后有小米公司的“小爱同学”。近日，百度公司在其世界大会上正式发布了自主研发的智能助手“文心一言”，引发了广泛关注。</p>
                  <a href="#" class="news-more">阅读更多</a>
                </div>
              </div>
            </div>
            
            <!-- 侧边栏 -->
            <div class="news-sidebar">
              <!-- 热门询问 -->
              <div class="sidebar-section">
                <h3 class="sidebar-title">热门询问</h3>
                <ul class="popular-questions">
                  <li><a href="#">智能城市数字孪生怎么念？“生”？</a></li>
                  <li><a href="#">为什么我们需要更多元化的人工智能？</a></li>
                  <li><a href="#">“是”等于“是”吗？</a></li>
                  <li><a href="#">为什么元宇宙和区块链技术的融合发展？</a></li>
                  <li><a href="#">智能城市数字孪生怎么念？“生”？</a></li>
                  <li><a href="#">苹果公司新款iPhone 15有哪些亮点？</a></li>
                </ul>
              </div>
              
              <!-- 标签云 -->
              <div class="sidebar-section">
                <h3 class="sidebar-title">标签云</h3>
                <div class="tag-cloud">
                  <a href="#" class="tag">人工智能</a>
                  <a href="#" class="tag">2023</a>
                  <a href="#" class="tag">互联网</a>
                  <a href="#" class="tag">网络安全</a>
                  <a href="#" class="tag">AI大模型</a>
                  <a href="#" class="tag">大数据</a>
                  <a href="#" class="tag">数字经济</a>
                  <a href="#" class="tag">后疫情</a>
                  <a href="#" class="tag">发展</a>
                </div>
              </div>
            </div>
          </div>
          
          <!-- 分页 -->
          <div class="pagination">
            <span class="page-btn">上一页</span>
            <span class="page-number active">1</span>
            <span class="page-number">2</span>
            <span class="page-number">3</span>
            <span class="page-number">4</span>
            <span class="page-number">5</span>
            <span class="page-dots">...</span>
            <span class="page-number">15</span>
            <span class="page-btn">下一页</span>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import { Images } from '@/utils/imageLoader';

export default {
  name: 'NewsView',
  data() {
    return {
      Images
    };
  }
}
</script>

<style scoped>
/* Hero Section */
.hero {
  position: relative;
  height: 72.5vh;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  overflow: hidden;
}

.hero-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}

.hero-bg-image {
    width: 100%;
  height: 100%;
  object-fit: cover;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.hero-content {
  text-align: left;
  color: white;
  z-index: 1;
  max-width: 1000px;
  padding: 0 80px;
  margin-left: 290px;
  margin-top: 380px;
}

.hero-title {
  font-size: 90px;
  font-weight: bold;
  margin-bottom: 10px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  letter-spacing: 2px;
  line-height: 1.2;
  color: #FFFFFF;
  margin: 0;
}

/* Breadcrumb */
.breadcrumb-section {
  padding: 20px 0;
}

.breadcrumb {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #666;
}

.breadcrumb-item {
  color: #666;
  text-decoration: none;
  transition: color 0.3s;
}

.breadcrumb-item:hover {
  color: #ff6b00;
}

.breadcrumb-item.active {
  color: #333;
  font-weight: 500;
}

.breadcrumb-separator {
  margin: 0 10px;
  color: #999;
}

/* News Main */
.news-main {
  padding: 60px 0;
}

.news-header {
  margin-bottom: 40px;
}

/* Search Box */
.search-box {
  display: flex;
  margin-bottom: 20px;
  max-width: 500px;
}

.search-input {
  flex: 1;
  padding: 12px 20px;
  border: 1px solid #e0e0e0;
  border-right: none;
  border-radius: 4px 0 0 4px;
  font-size: 16px;
  outline: none;
}

.search-btn {
  padding: 12px 20px;
  color: white;
  border: none;
  border-radius: 0 4px 4px 0;
  cursor: pointer;
  transition: background-color 0.3s;
}

.search-btn:hover {
  background-color: #e55a00;
}

.search-icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.date-icon {
  width: 14px;
  height: 14px;
  margin-right: 8px;
  vertical-align: middle;
}


/* News Tabs */
.news-tabs {
  display: flex;
  gap: 20px;
}

.tab {
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  color: #666;
  border-radius: 4px;
  transition: all 0.3s;
}

.tab.active {
  background-color: #ff6b00;
  color: white;
}

/* News Layout */
.news-layout {
  display: flex;
  gap: 40px;
}

.news-list {
  flex: 1;
}

/* News Item */
.news-item {
  display: flex;
  margin-bottom: 40px;
  padding-bottom: 40px;
  border-bottom: 1px solid #e0e0e0;
}

.news-item:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.news-image {
  width: 200px;
  height: 150px;
  overflow: hidden;
  border-radius: 4px;
  margin-right: 30px;
}

.news-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s;
}

.news-image:hover img {
  transform: scale(1.1);
}

.news-info {
  flex: 1;
}

.news-meta {
  display: flex;
  gap: 20px;
  margin-bottom: 15px;
  font-size: 14px;
  color: #999;
}

.news-category {
  background-color: #f0f0f0;
  padding: 4px 12px;
  border-radius: 4px;
}

.news-title {
  margin: 0 0 15px;
  font-size: 22px;
  font-weight: 500;
  color: #333;
}

.news-excerpt {
  margin: 0 0 20px;
  font-size: 16px;
  line-height: 1.6;
  color: #666;
}

.news-more {
  color: #ff6b00;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s;
}

.news-more:hover {
  color: #e55a00;
}

/* News Sidebar */
.news-sidebar {
  width: 300px;
}

.sidebar-section {
  margin-bottom: 40px;
  padding: 20px;
  background-color: #f8f8f8;
  border-radius: 4px;
}

.sidebar-title {
  margin: 0 0 20px;
  font-size: 18px;
  font-weight: 500;
  color: #333;
}

/* Popular Questions */
.popular-questions {
  list-style: none;
  margin: 0;
  padding: 0;
}

.popular-questions li {
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid #e0e0e0;
}

.popular-questions li:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.popular-questions a {
  color: #666;
  text-decoration: none;
  transition: color 0.3s;
  font-size: 14px;
  line-height: 1.5;
}

.popular-questions a:hover {
  color: #ff6b00;
}

/* Tag Cloud */
.tag-cloud {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.tag {
  padding: 6px 12px;
  background-color: white;
  color: #666;
  text-decoration: none;
  border-radius: 4px;
  font-size: 14px;
  transition: all 0.3s;
  border: 1px solid #e0e0e0;
}

.tag:hover {
  background-color: #ff6b00;
  color: white;
  border-color: #ff6b00;
}

/* Pagination */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin-top: 60px;
}

.page-btn {
  padding: 10px 16px;
  background-color: white;
  border: 1px solid #e0e0e0;
  color: #666;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.3s;
}

.page-btn:hover {
  background-color: #f0f0f0;
}

.page-number {
  padding: 10px 16px;
  background-color: white;
  border: 1px solid #e0e0e0;
  color: #666;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.3s;
}

.page-number:hover {
  background-color: #f0f0f0;
}

.page-number.active {
  background-color: #ff6b00;
  color: white;
  border-color: #ff6b00;
}

.page-dots {
  padding: 10px 16px;
  color: #999;
}

/* Responsive Design */
@media (max-width: 768px) {
  .hero-title {
    font-size: 36px;
  }
  
  .news-layout {
    flex-direction: column;
  }
  
  .news-sidebar {
    width: 100%;
  }
  
  .news-item {
    flex-direction: column;
  }
  
  .news-image {
    width: 100%;
    height: auto;
    margin-right: 0;
    margin-bottom: 20px;
  }
}
</style>